import React, { useContext, useState } from 'react';
import PageFooter from '../partials/PageFooter';
import { Routes } from '../Routing';
import LabSimService, { StateContext } from '../services/LabSimService';
import PlatformHelper, { Roles } from '../helpers/PlatformHelper';
import HoverTile from '../controls/HoverTile';
import ManualSyncDialog from '../controls/gradesync/ManualSyncDialog';
import { T } from '@testout/labsim-ui-atomics';
import styles from './Home.module.less';
import { version } from '../version';
import { IconVariation } from '@testout/icon-library';
import RetirementNotice from './retirement-notice.dialog';
import { FeatureFlags } from '../components/feature-flags/feature-flags';
export default ({ history }) => {
    const stateContext = useContext(StateContext);
    const [isManualSyncDialogOpen, setIsManualSyncDialogOpen] = useState(false);
    const gotoBrowseProducts = () => {
        history.push(Routes.BROWSE);
    };
    const gotoBrowseCustomExams = () => {
        history.push(Routes.CUSTOM_EXAMS);
    };
    const gotoBrowseCertifications = () => {
        history.push(Routes.CERTIFICATIONS);
    };
    const gotoSettings = () => {
        history.push(Routes.SETTINGS);
    };
    const gotoGradeSync = () => {
        if (PlatformHelper.isIntegrationLTIAdvantage(stateContext.serverState)) {
            setIsManualSyncDialogOpen(true);
            return;
        }
        history.push(Routes.SYNC);
    };
    const closeManualSyncDialog = () => {
        setIsManualSyncDialogOpen(false);
    };
    const displaySyncButton = (serverState) => {
        var _a;
        if (!PlatformHelper.hasAnyRole(serverState, Roles.ADMIN, Roles.INSTRUCTOR, Roles.CONTENT_DEV)) {
            return false;
        }
        if (PlatformHelper.isIntegrationLTIAdvantage(serverState)) {
            return (_a = stateContext === null || stateContext === void 0 ? void 0 : stateContext.featureFlags) === null || _a === void 0 ? void 0 : _a[FeatureFlags.GRADE_SYNC];
        }
        return true;
    };
    const displaySettingsButton = (serverState) => {
        return PlatformHelper.hasAnyRole(serverState, Roles.ADMIN, Roles.INSTRUCTOR);
    };
    return (React.createElement(React.Fragment, null,
        stateContext.showRetirementNotice && React.createElement(RetirementNotice, null),
        isManualSyncDialogOpen && (React.createElement(ManualSyncDialog, { isOpen: isManualSyncDialogOpen, onClose: closeManualSyncDialog })),
        React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.mainMenu },
                React.createElement(T.Text.H1, { variation: T.Text.Variation.H1_Large, automationId: 'createTitle', className: styles.title }, "Create Assignments"),
                React.createElement("div", { className: styles.tiles },
                    React.createElement(HoverTile, { id: 'addLicensedButton', text: 'Course Resources', onClick: gotoBrowseProducts },
                        React.createElement(T.Icon, { automationId: 'addLicensedButton-icon', variation: IconVariation.Hammer, className: styles.icon })),
                    React.createElement(HoverTile, { text: 'Custom Quizzes', onClick: gotoBrowseCustomExams, id: 'customExamsButton' },
                        React.createElement(T.Icon, { automationId: 'customExamsButton-icon', variation: IconVariation.BallotCheck, className: styles.icon })),
                    React.createElement(HoverTile, { text: 'Class Assessments', onClick: gotoBrowseCertifications, id: 'certificationsButton' },
                        React.createElement(T.Icon, { automationId: 'certificationsButton-icon', variation: IconVariation.Ribbon, className: styles.icon }))),
                React.createElement("div", { className: styles.links },
                    displaySyncButton(stateContext.serverState) && (React.createElement(T.Button, { automationId: 'synchronizeButton', variation: T.ButtonVariation.SecondaryText, onClick: gotoGradeSync, className: styles.button },
                        React.createElement(T.IconText, { variation: T.Text.Variation.Inherit, automationId: 'text', leftIconVariation: T.IconVariation.Sync }, "Sync Grades"))),
                    displaySettingsButton(stateContext.serverState) && (React.createElement(T.Button, { automationId: 'settingsButton', onClick: gotoSettings, variation: T.ButtonVariation.SecondaryText, className: styles.button },
                        React.createElement(T.IconText, { variation: T.Text.Variation.Inherit, leftIconVariation: T.IconVariation.GearOutline, className: styles.settingsIcon, automationId: 'icon' }, "Settings"))))),
            React.createElement("div", { className: styles.versionBlock }, stateContext && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.version },
                    `Version ` + version,
                    " ",
                    LabSimService.getLS6Target(),
                    ' ',
                    stateContext && ` - ${stateContext.serverState.integrationType}`),
                React.createElement("div", { className: styles.indicators, "data-automationid": 'loaded-indicator' },
                    React.createElement("div", { className: stateContext.canvasDataLoaded
                            ? styles.loaded
                            : stateContext.canvasDataFailed
                                ? styles.failedLoad
                                : '' }),
                    React.createElement("div", { className: stateContext.productsLoaded ? styles.loaded : '' }),
                    React.createElement("div", { className: stateContext.customExams ? styles.loaded : '' }))))),
            React.createElement(PageFooter, null))));
};
//# sourceMappingURL=Home.js.map